import useNativeListener from './useNativeListener';

interface GoogleSignInData {
    isSuccess: boolean;
    idToken?: string;
}

interface Props {
    callbackFn: (data:GoogleSignInData) => void;
    deps?: any[];
}

function useOnGoogleSignIn({ callbackFn, deps }:Props) {
    useNativeListener('requestGoogleSignin', callbackFn, deps);
}

export default useOnGoogleSignIn;
